import { render, staticRenderFns } from "./count-to.vue?vue&type=template&id=cca21970&scoped=true&"
import script from "./count-to.vue?vue&type=script&lang=js&"
export * from "./count-to.vue?vue&type=script&lang=js&"
import style0 from "./count-to.vue?vue&type=style&index=0&id=cca21970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca21970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca21970')) {
      api.createRecord('cca21970', component.options)
    } else {
      api.reload('cca21970', component.options)
    }
    module.hot.accept("./count-to.vue?vue&type=template&id=cca21970&scoped=true&", function () {
      api.rerender('cca21970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/count-to.vue"
export default component.exports